<template>
  <div class="user">
    <div class="common-level-rail">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" v-auth="'/product/solution/add'">
            添加解决方案
          </el-button>
        </el-form-item>
        <el-form-item label="方案标题">
          <el-input size="small" v-model="searchForm.name" placeholder="请输入方案标题"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="id" width="70" label="方案Id">
          </el-table-column>
          <el-table-column prop="categoryName" width="160" label="方案分类">
          </el-table-column>
          <el-table-column prop="title" label="方案名称" min-width="160"></el-table-column>
          <el-table-column prop="content" label="方案描述" min-width="160">
          </el-table-column>
          <el-table-column prop="solutionProductList" label="涉及产品" min-width="260">

          </el-table-column>
          <el-table-column prop="isPicture" label="图例" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.isPicture==0">没有</span>
              <span v-else>有</span>
            </template>
          </el-table-column>
          <!--          <el-table-column prop="sort" label="排序" width="100"></el-table-column>-->
          <el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small">
                编辑
              </el-button>
              <el-button @click="delClick(scope.row)" type="text" size="small">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                       :current-page="curPage"
                       :page-size="pageSize" layout="total, prev, pager, next, jumper"
                       :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="添加解决方案" :visible.sync="dialogVisible" @close="dialogFormVisible"
               :close-on-press-escape="false"
               top="5vh">
      <div style="display: block">
        <el-form size="mini" label-position="left" ref="editform" :model="editform" label-width="100px">
          <el-form-item label="方案标题:" prop="title" :rules="[{ required: true, message: '请输入方案标题' }]">
            <el-input v-model="editform.title" placeholder="方案标题" class="max-w460"></el-input>
          </el-form-item>
          <el-form-item prop="categoryValues" label="方案分类:"
                        :rules="[{ required: true, message: '请选择方案分类' }]">
            <el-cascader :options="options" style="width: 460px"
                         :props="{ checkStrictly: true,value:'id',label:'name',children:'children' }"
                         ref="cascader"
                         v-model="editform.categoryValues"
                         @change="changeCategory"
                         clearable></el-cascader>
          </el-form-item>
          <el-form-item label="方案描述:" prop="content" :rules="[{ required: true, message: '请输入方案描述' }]">
            <el-input type="textarea" v-model="editform.content" placeholder="方案描述" class="max-w460"></el-input>
          </el-form-item>
          <el-form-item label="图例：">
            <div class="draggable-list">
              <draggable class="wrapper" v-model="editform.imageList">
                <transition-group>
                  <div class="item" v-for="(item, index) in editform.imageList" :key="item + index">
                    <img v-img-url="item.filePath"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i
                      class="el-icon-close"></i></a>
                  </div>
                </transition-group>
              </draggable>
              <div class="item img-select" @click="openProductUpload('image', 'imageList')"><i class="el-icon-plus"></i>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="方案产品：">
            <el-table size="mini" :data="editform.solutionProductList" border
                      style="width: 100%; margin-top: 10px">
              <el-table-column label="产品名称">
              </el-table-column>
              <el-table-column label="规格">
              </el-table-column>
              <el-table-column label="数量">
              </el-table-column>
              <el-table-column label="操作" header-align="center">
                <template slot="header" slot-scope="scope">
                  <span style="color: red;cursor: pointer">添加产品</span>
                </template>
                <template slot-scope="scope">
                  <el-button @click="editClick(scope.row)" type="text" size="small">
                    编辑
                  </el-button>
                  <el-button @click="delClick(scope.row)" type="text" size="small">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible=false">取 消</el-button>
        <el-button size="small" type="primary" @click="addSolution">确 定</el-button>
      </div>
    </el-dialog>
    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">
      上传图片
    </Upload>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js'
import draggable from 'vuedraggable'
import Upload from '@/components/file/Upload'
import CropApi from '@/api/crop.js'

export default {
  name: 'index',
  components: {
    draggable,
    Upload
  },
  data () {
    return {
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*总条数*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      dialogVisible: false,
      /*搜索参数*/
      searchForm: {
        name: ''
      },
      editform: {
        id: 0,
        categoryValues: [],
        categoryId: 0,
        productId: 0,
        title: '',
        content: '',
        imageList: [],
        productName: '',
        solutionProductList: []
      },
      options: [],
      config: {},
      isProductUpload: false,
      file_name: 'image',
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.getData()
      this.getCropOption()
    },
    /*搜索查询*/
    onSubmit () {
      this.curPage = 1
      this.getData()
    },
    getCropOption () {
      let self = this
      CropApi.cropList({}, true)
        .then(res => {
          self.options = res.data || []
        })
        .catch(error => {
        })

    },
    addClick () {
      this.editform = {
        id: 0,
        categoryValues: [],
        categoryId: 0,
        productId: 0,
        title: '',
        content: '',
        imageList: [],
        productName: '',
        solutionProductList: []
      }
      this.dialogVisible = true
    },

    editClick (row) {
      let usageId = row.id
      PorductApi.getUsageDetail({usageId}, true).then(res => {
        let data = res.data
        let cropDiseaseList = []
        let cropTypeId = data.cropTypeId || 0
        if (cropTypeId) {
          cropDiseaseList.push(cropTypeId)
          let cropId = data.cropId || 0
          if (cropId) {
            cropDiseaseList.push(cropId)
            let diseaseId = data.diseaseId || 0
            if (diseaseId) {
              cropDiseaseList.push(diseaseId)
            }
          }
        }
        this.editform = {
          id: data.id || 0,
          cropDiseaseList: cropDiseaseList,
          formulationDosage: data.formulationDosage || '',
          useMethod: data.useMethod || '',
          imageList: data.imageList || [],
          productId: this.form.model.productId,
          productName: this.form.model.productName || ''
        }
        this.dialogVisible = true
      }).catch(error => {
        console.log(error)
      })
    },

    addSolution () {
      this.$refs.editform.validate((valid) => {
        if (valid) {
          let self = this
          let params = {}
          Object.assign(params, this.editform)
          params.categoryValues = this.editform.categoryValues.join(',')
          if (this.editform.id) {
            PorductApi.editProductSolution(params).then(data => {
              self.$message({
                message: '操作成功',
                type: 'success'
              })
              this.getData()
              self.dialogVisible = false
            })
          } else {
            PorductApi.addProductSolution(params).then(data => {
              self.$message({
                message: '操作成功',
                type: 'success'
              })
              this.getData()
              self.dialogVisible = false
            })
          }
        }
      })
    },

    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.curPage = val
      self.loading = true
      self.getData()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.curPage = 1
      this.pageSize = val
      this.getData()
    },
    getData () {
      let self = this
      self.loading = true
      let Params = self.searchForm
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      Params.status = self.status
      PorductApi.getSolutionList(Params, true).then(res => {
        self.loading = false
        self.tableData = res.data.records
        self.totalDataNumber = res.data.total
      }).catch(error => {
        self.loading = false
      })
    },
    dialogFormVisible (e) {
      this.editform = {
        id: 0,
        categoryValues: [],
        categoryId: 0,
        productId: 0,
        title: '',
        content: '',
        imageList: [],
        productName: '',
        solutionProductList: []
      }
    },
    openProductUpload: function (file_type, file_name) {
      this.file_name = file_name
      if (this.file_name === 'imageList') {
        this.config = {
          total: 9,
          fileType: file_type
        }
      }
      this.isProductUpload = true
    },
    returnProductImgsFunc (e) {
      if (e != null) {
        // 兼容后端
        if (e.length > 0) {
          if (this.file_name === 'imageList') {
            this.editform.imageList = this.editform.imageList.concat(e)
          }
        }
      }
      this.isProductUpload = false
    },
    /*删除商品图片*/
    deleteImg (index) {
      this.editform.imageList.splice(index, 1)
    },
    changeCategory (e) {
      let item = this.$refs['cascader'].getCheckedNodes()
      if (item && item.length) {
        this.editform.categoryId = item[0].data.id
      } else {
        this.editform.categoryId = ''
      }
    },
    delClick: function (row) {
      let self = this
      self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        PorductApi.delSolution({
          solutionId: row.id
        }).then(data => {
          self.$message({
            message: '删除成功',
            type: 'success'
          })
          self.getData()
        })
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/product/solution/index.vue